/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ETicketLayoutStyle } from 'app/modules/design/e-ticket-design/e-ticket-design-management/models/e-ticket-layout-style';

const customValueProvider = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => LayoutPickerComponent),
	multi: true,
};
const customValidateProvider = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => LayoutPickerComponent),
	multi: true,
};

@Component({
	selector: 'layout-picker',
	templateUrl: './layout-picker.component.html',
	styleUrls: ['./layout-picker.component.scss'],
	providers: [customValueProvider, customValidateProvider],
	standalone: false,
})
export class LayoutPickerComponent implements ControlValueAccessor {
	@Input() layoutStyleLookupData: any[];
	writtenValue: any;
	@Input() startTabIndex = 1;

	onLayoutStyleSelected(layoutStyle: ETicketLayoutStyle) {
		this.writeValue(layoutStyle);
		this.propagateChange(layoutStyle);
		this.onTouched();
	}

	propagateChange: any = () => {};
	onTouched: any = () => {};

	writeValue(eTicketLayoutStyle: ETicketLayoutStyle): void {
		this.writtenValue = eTicketLayoutStyle;
	}

	registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	public validate(c: FormControl) {
		return null;
	}

	getIcons(id: number): string[] {
		return [];
	}

	getLabel(id: number): string {
		return '';
	}

	getTooltip(id: number): string {
		return '';
	}
}
